"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultMaxListeners = void 0;
exports.defaultParser = defaultParser;
exports.defaultParserJSON = defaultParserJSON;
function defaultParser(data) {
  return data;
}
function defaultParserJSON(data) {
  return JSON.parse(data);
}
const defaultMaxListeners = 30;
exports.defaultMaxListeners = defaultMaxListeners;